module.exports = __webpack_public_path__ + "media/images/vector-34@2x-c3149ba0ebadee6fc4a0ecd5c77e271e.png";